import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TermGuidelineCategory from '@/components/TermGuidelineCategory';

const QualityGuidelineBoxPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">クオリティガイドライン - 未開封ボックス</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">出品条件</div>
            </div>
            <div className="justify-center">
              <span className="text-black text-base font-normal leading-7">出品の対象となるのは、以下のすべての条件を満たしている商品に限られます。<br/>いずれか一つでも該当しない場合は、出品いただくことはできません。<br/></span>
              <span className="text-black text-base font-normal leading-7 pl-8">・未使用、未開封かつシュリンク付きであること<br/></span>
              <span className="text-black text-base font-normal leading-7 pl-8">・商品本体および付属品に汚れや破損がないこと<br/></span>
              <span className="text-black text-base font-normal leading-7"><br/>また、販売経路を問わず出品を許可しているため、以下のような状態の商品についても出品が可能です。<br/></span>
              <span className="text-black text-base font-normal leading-7">・シュリンクにマジック等でマーキングがされている<br/>・箱に販売元の保証印が押されている<br/>・商品にバーコード（タグ）が直接貼付されている<br/></span>
              <span className="text-black text-base font-normal leading-7">※販売店が貼付したと考えられるバーコード・タグに限ります<br/><br/>メーカー工場で発生する可能性のある軽微な汚れや、シュリンクの緩みなどについては、正規販売店でも一般的に見られるものであることから、DONDONでは基準内の状態として取り扱っております。</span>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">注意事項</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center">
                <span className="text-black text-base font-normal leading-7">・ガイドラインに記載されている内容はあくまで一例であり、商品ごとに状態レベルの基準が変動する場合があります。<br/>・掲載されている商品画像は、撮影環境などの影響により、実物と色味が異なって見えることがあります。<br/>・商品の検品時には、選択された商品状態がガイドラインの基準と一致しているかを確認しております。<br/>・補足説明に記載された内容よりも、ガイドラインで定められた基準が優先されます。<br/></span>
                <span className="text-black text-base font-normal leading-7">※なお、商品状態にかかわらず、購入者様に誤解を与えるような表現や、出品情報と大きく異なる内容が記載されている場合は、取引がキャンセルとなる可能性があります。</span>
              </div>
              <div className="flex flex-col justify-start items-start">
                <div className="justify-center text-black text-base font-normal leading-7">すべての出品に共通するルールや、出品情報に関する詳細については、以下のページもあわせて必ずご確認ください。</div>
                <Link to={`/terms/guideline_listing${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">出品ガイドライン</Link>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">商品の状態</div>
            </div>
            <div className={`w-full grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-[30px]`}>
              <img className="w-full h-auto" src="/images/terms/guideline_box_1.jpg" alt="出品可能な商品例 1" />
              <img className="w-full h-auto" src="/images/terms/guideline_box_2.jpg" alt="出品可能な商品例 2" />
              <img className="w-full h-auto" src="/images/terms/guideline_box_3.jpg" alt="出品不可な商品例" />
            </div>
          </div>
          
          <TermGuidelineCategory />
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default QualityGuidelineBoxPage;